import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import FormValue from '../../../../components/form/FormValue/FormValue';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import styles from './SerialCodeModal.module.scss';

export interface SerialCodeModalInputCodeUIProps {
  initialValue?: string;
  onChange: (value: string) => void;
  valid: () => void;
  SerialCodeInputComponent: React.ComponentType<{ initialValue?: string; onChange: (value: string) => void }>;
}

export interface SerialCodeModalConfirmUIProps {
  serialCode: string;
  campaignData: {
    lotteryEventName: string;
    lotteryEventBranchId: number;
    lotteryEventBranchName: string;
    caution: string;
  };
  draw: () => void;
  isLoading: boolean;
}

export function SerialCodeModalInputCodeUI({
  initialValue,
  onChange,
  valid,
  SerialCodeInputComponent,
}: SerialCodeModalInputCodeUIProps) {
  return (
    <>
      <h2 className={layoutStyles.modalTitle}>シリアルコード入力</h2>
      <div className={utilsStyles.mtSmall}>
        <SerialCodeInputComponent initialValue={initialValue} onChange={onChange} />
      </div>
      <div className={utilsStyles.mtSmall}>
        <ActionButton color='primary' onClick={valid} size='fullWidth' data-testid='apply-code-button'>
          コードを適用する
        </ActionButton>
      </div>
    </>
  );
}

export function SerialCodeModalConfirmUI({ serialCode, campaignData, draw, isLoading }: SerialCodeModalConfirmUIProps) {
  return (
    <>
      <h2 className={layoutStyles.modalTitle}>シリアルコードを使用してくじを引きます</h2>
      <div className={utilsStyles.mtSmall}>
        <FormValue label=''>
          <div className={`${utilsStyles.textSmall} ${utilsStyles.centered} ${utilsStyles.spaceBetween}`}>
            <span>適用されたコード</span>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold} ${styles.textSerialCode}`}>
              <em>{serialCode}</em>
            </p>
          </div>
        </FormValue>
        <hr className={utilsStyles.pinkishgrayBgColor} />
        <div className={`${utilsStyles.mtSmall} ${utilsStyles.textCenter}`}>
          <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>対象くじイベント</p>
        </div>
        <hr className={`${utilsStyles.pinkishgrayBgColor} ${utilsStyles.mtXSmall}`} />
        <div
          className={`${utilsStyles.mtSmall} ${utilsStyles.textCenter} ${utilsStyles.textSmall} ${utilsStyles.primaryColor} ${utilsStyles.textBold}`}
        >
          {campaignData.lotteryEventBranchName}
        </div>
        <hr className={`${utilsStyles.pinkishgrayBgColor} ${utilsStyles.mtXSmall}`} />
        <div className={`${utilsStyles.mtSmall} ${styles.itemCaution}`}>
          <p className={`${utilsStyles.textSmall} ${utilsStyles.textPrewrap}`}>{campaignData.caution}</p>
        </div>
        <div className={utilsStyles.mtSmall}>
          <ActionButton
            size='fullWidth'
            color='primary'
            onClick={draw}
            disabled={isLoading}
            isLoading={isLoading}
            data-testid='ok-button'
          >
            {isLoading ? '・・・' : 'くじを引く'}
          </ActionButton>
        </div>
      </div>
    </>
  );
}
